import type { LoggerHostDeps, LoggerWriter } from './hostDeps';

// One save's writer and its failure text, out of useSaveWorkout (#42).

/** Bind this save to the account signed in now (`openWrite`), before
 *  anything is sent. Its only refusal is "nobody signed in": the draft stays
 *  and the athlete is told. Hosts without it (web-rnw) write through the
 *  plain deps. */
export function openSaveWriter(
  deps: LoggerHostDeps,
): { writer: LoggerWriter } | { error: string } {
  try {
    return { writer: deps.openWrite?.() ?? deps };
  } catch {
    return { error: 'mobile.logger.errNotSignedIn' };
  }
}

/** A save that reached neither the server nor the queue: the error's own
 *  `mobile.logger.*` key or text, else the generic failure. */
export const saveFailureMessage = (err: unknown): string =>
  err instanceof Error ? err.message : 'mobile.logger.errSaveFailed';

/** The save error in words: a `mobile.logger.*` key is translated, any other
 *  text (a schema message, an error's own) is shown as it came. */
export const saveErrorText = (
  error: string,
  t: (k: string) => string,
): string => (error.startsWith('mobile.logger.') ? t(error) : error);
